module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-layout"
  }, [_c('div', {
    ref: "layoutWrap",
    staticClass: "layout-wrap"
  }, [_c('div', {
    staticClass: "page-title"
  }, [_vm._t("page-title")], 2), _vm._v(" "), _c('div', {
    staticClass: "page-content clearfix"
  }, [_c('div', {
    staticClass: "top"
  }, [_vm._t("top")], 2), _vm._v(" "), _c('div', {
    staticClass: "left-area"
  }, [_vm._t("left-area")], 2), _vm._v(" "), _c('div', {
    staticClass: "right-area"
  }, [_vm._t("right-area")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "page-footer"
  }, [_vm._t("page-footer")], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2a61e768!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/layout-contest/index.vue
// module id = 230
// module chunks = 0